export default "__VITE_ASSET__PHkHdQoX__"